export const STATUS_OPTIONS = ['Diproses', 'Disetujui', 'Ditolak'];

export const DEFAULT_FILTERS = {
  searchName: '',
  searchAlamat: '',
  searchNameKK: '',
  searchNoKK: '',
  searchNik: '',
  tanggalDiterima: "", 
  tanggalSurat: "",
  tanggalMulaiDiterima: "",
  tanggalSelesaiDiterima: "",
  tanggalMulaiSurat: "",
  tanggalSelesaiSurat: "",
  status: '',
  tanggalMulai: '',
  tanggalSelesai: '',
  kecamatan: '',
  kelurahan: '',
  tahun: '',
  perihal: '',
  user: ''
};

export const kecamatanOptions = {
  "Taliwang": [
    "Menala", "Dalam", "Sampir", "Kuang", "Bugis", "Arab Kenangan", 
    "Telaga Bertong", "Tamekan", "Seloto", "Lamunga", "Batu Putih", 
    "Banjar", "Sermong", "Labuhan Kertasari", "Labuhan Lalar", "Lalar Liang"
  ],
  "Seteluk": [
    "Seteluk Tengah", "Seteluk Atas", "Seran", "Rempe", "Tapir", 
    "Air Suning", "Kelanir", "Lamusung", "Desa Loka", "Meraran"
  ],
  "Poto Tano": [
    "Poto Tano", "Kokarlian", "Tambak Sari", "Tebo", "Senayan", 
    "Kiantar", "Tuananga", "Mantar"
  ],
  "Brang Rea": [
    "Lamuntet", "Rarak Ronges", "Bangkat Monteh", "Moteng", 
    "Tepas Sepakat", "Tepas", "Sapugara Bree", "Seminar Salit", "Desa Beru"
  ],
  "Brang Ene": [
    "Lampok", "Mujahidin", "Kalimantong", "Manemeng", "Mataiyang", "Mura"
  ],
  "Jereweh": [
    "Dasan Anyar", "Goa", "Beru", "Belo"
  ],
  "Maluk": [
    "Benete", "Bukit Damai", "Mantun", "Pasir Putih", "Maluk"
  ],
  "Sekongkang": [
    "Talonang Baru", "Tatar", "Ai Kangkung", "Sekongkang Atas", 
    "Tongo", "Kemuning", "Sekongkang Bawah"
  ]
};

export const kecamatanDesa = {
  "Taliwang": ["Menala", "Dalam", "Sampir", "Kuang", "Bugis", "Arab Kenangan", "Telaga Bertong", "Tamekan", "Seloto", "Lamunga", "Batu Putih", "Banjar", "Sermong", "Labuhan Kertasari", "Labuhan Lalar", "Lalar Liang"],
  "Seteluk": ["Seteluk Tengah", "Seteluk Atas", "Seran", "Rempe", "Tapir", "Air Suning", "Kelanir", "Lamusung", "Desa Loka", "Meraran"],
  "Poto Tano": ["Poto Tano", "Kokarlian", "Tambak Sari", "Tebo", "Senayan", "Kiantar", "Tuananga", "Mantar"],
  "Brang Rea": ["Lamuntet", "Rarak Ronges", "Bangkat Monteh", "Moteng", "Tepas Sepakat", "Tepas", "Sapugara Bree", "Seminar Salit", "Desa Beru"],
  "Brang Ene": ["Lampok", "Mujahidin", "Kalimantong", "Manemeng", "Mataiyang", "Mura"],
  "Jereweh": ["Dasan Anyar", "Goa", "Beru", "Belo"],
  "Maluk": ["Benete", "Bukit Damai", "Mantun", "Pasir Putih", "Maluk"],
  "Sekongkang": ["Talonang Baru", "Tatar", "Ai Kangkung", "Sekongkang Atas", "Tongo", "Kemuning", "Sekongkang Bawah"],
};

export const perihalOptions = [
  "Rehab Rumah Tidak Layak Huni",
  "Pembangunan Rumah Layak Huni",
  "Meteran Listrik 900 VA",
]

export const DATE_PLACEHOLDER = 'YYYY-MM-DD';